const merge = require('lodash/merge');
const config = require('./config.common');

module.exports = merge({}, config, {
  environment: 'dev',
  isPublisherActive: true,
  app: {
    protocol: 'https',
    host: 'prog.dev.viooh.net.cn',
    port: null,
  },
  api: {
    BASE_URL: 'https://gateway-api.devel.viooh.net.cn/',
  },
  gatewayApi: {
    BASE_URL: 'https://gateway-api.devel.viooh.net.cn/',
  },
  keycloak: {
    url: 'https://keycloak.devel.viooh.net.cn/',
    realm: 'dev-cn',
    clientId: 'trading-manager-ui-front',
  },
  authProvider: 'Keycloak',
  thoughtspot: {
    host: 'https://viooh.thoughtspot.cloud/',
    identifier: 'development',
    dealHealthDashboardId: '7f0bc617-092f-464b-9490-cabe78f5f433',
    resellerDealHealthDashboardId: '17a46a4d-598b-44fe-b4d8-d6042e69ab5d',
    dealManagementMetrics: '8149572b-ba58-4abc-a9de-675d66c18fb5',
    todaysRevenueVizId: '7bdd8e90-880b-49d9-8426-30ce3b8ced27',
    monthToDateVizId: 'ac1f5944-520c-4453-ac70-8563d6c90c4c',
    chinaProofOfPlayLiveboardId: '4062351b-077b-41b8-9a1a-1e4220ecabef',
    chinaDealHealthLiveboardId: '579e6851-0018-4237-9f9e-a2c096f6e893',
    assetHealthLiveboardId: 'cec85081-8d6c-4be6-8e8c-5b10d83638c8',
    quickDeliveryStatsLiveboardId: '7f0bc617-092f-464b-9490-cabe78f5f433',
    quickDeliveryStatsVisualizationId: '7babc7f9-a7f3-45d9-ac4b-149bc2ab392b',
  },
  dataDog: {
    defaultPrivacyLevel: 'allow',
  },
  features: (market) => {
    return {
      ...config.features(market),
      GOOGLEMAPS: false,
    };
  },
});
